import { createRouter, createWebHistory } from "vue-router";
import { useAuthStore } from "@/stores/auth";

const routes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/Login.vue"),
    meta: { requiresGuest: true },
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("@/views/Register.vue"),
    meta: { requiresGuest: true },
  },
  {
    path: "/",
    name: "Dashboard",
    component: () => import("@/views/Dashboard.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/subscriptions",
    name: "Subscriptions",
    component: () => import("@/views/Subscriptions.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/subscriptions/add",
    name: "AddSubscription",
    component: () => import("@/views/AddSubscription.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/subscriptions/edit/:id",
    name: "EditSubscription",
    component: () => import("@/views/AddSubscription.vue"),
    meta: { requiresAuth: true },
    props: true // 将路由参数作为组件的 props 传递
  },
  {
    path: "/categories",
    name: "Categories",
    component: () => import("@/views/Categories.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/support",
    name: "Support",
    component: () => import("@/views/Support.vue"),
    meta: { requiresAuth: true },
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore();

  // 检查令牌是否即将过期，如果是，尝试刷新
  if (authStore.isAuthenticated && authStore.isTokenExpiringSoon) {
    console.log("Token is expiring soon, attempting to refresh");
    await authStore.tryRefreshToken();
  }

  // 认证路由检查
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!authStore.isAuthenticated) {
      // 用户未认证，重定向到登录页
      return next({
        name: "Login",
        query: { redirect: to.fullPath }, // 存储尝试访问的URL
      });
    }
    // 用户已认证，允许访问
    return next();
  }

  // 仅限游客的路由检查
  if (
    to.matched.some((record) => record.meta.requiresGuest) &&
    authStore.isAuthenticated
  ) {
    // 用户已登录，重定向到主页
    return next({ name: "Dashboard" });
  }

  // 默认情况下允许访问
  return next();
});

export default router;
